import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonsModule } from '@shared/core/components/buttons';
import { LoadersModule } from '@shared/core/components/loaders';

import { SliderSimpleComponent } from './slider-simple.shared.component';

import { SliderComponentsModule } from '../../components';

@NgModule({
    declarations: [
        SliderSimpleComponent
    ],
    imports: [
        CommonModule,
        ButtonsModule,
        LoadersModule,
        SliderComponentsModule,
    ],
    exports: [
        SliderSimpleComponent
    ],
})
export class SliderSimpleModule { }
